import request, { ResultHandler } from '@/core/utils/request'
const StockBaseUrl = '/business/stock'
export async function searchStock(data) {
  const result = await request({
    url: StockBaseUrl,
    method: 'GET',
    params: data
  })
  return ResultHandler(result, 'Search stock failed!')?.list ?? []
}

export const PDAApkUrl = '/api/warehouse/business/stock/pda'
